module.exports = __webpack_public_path__ + "img/18.ce3666a2.png";